/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { NavLink, Redirect, useHistory } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Dropdown, OverlayTrigger, Row, Col, Tooltip, Image, Modal, Button } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../../../_metronic/_partials/dropdowns";
import { Divider } from "@material-ui/core";
import { Delete, DeleteOutlineRounded } from "@material-ui/icons";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useFormik } from "formik";
import { deactivate } from "../../Auth/_redux/authCrud";
import { FormattedMessage } from "react-intl";
// import * as actions from "../_redux/Profile/profileActions";

export function ProfileCard() {
  // const dispatch = useDispatch();
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const accountItems = useSelector(
    (state) => state.profileSlice.accountItems,
    shallowEqual
  );
  const history = useHistory()
  // useEffect(() => {
  //   return () => {};
  // }, [user]);

  const [show, setShow] = useState()
  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };
  // useEffect(() => {
  //   dispatch(actions.getProfile());
  // }, []);

  // const formik = useFormik({
  //   onSubmit: (values, { setStatus, setSubmitting }) => {
  //     enableLoading();

  //   },
  // });
  const handleSubmit = () => {
    enableLoading();
    setTimeout(() => {
      deactivate()
        .then((data) => {
          if (data.error) {
            disableLoading();
          }
          else {
            disableLoading();
            setShow(false)
            history.push("/logout");
          }
        })
        .catch((data) => {
          // setStatus(data.message);
        })
        .finally(() => {
          disableLoading();
          // history.push("/logout");
          // setSubmitting(false);
        });
    }, 1000);
  };
  return (
    <>
      {user && (
        <div
          className="flex-row-auto"
          id="kt_profile_aside"
        >
         
        </div>
      )}

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header
          closeButton
        // style={{ borderBottom: "0px" }}
        >
          <Modal.Title
            className="justify-content-start" id="example-modal-sizes-title-lg">

          </Modal.Title></Modal.Header>
        <Modal.Body>
          <div
            // onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework"
          >
            <><FormattedMessage id="DEACTIVATE_ACCOUNT_CONF"></FormattedMessage></>
          </div>
        </Modal.Body>
        <Modal.Footer
          // style={{ borderTop: "0px" }}
          className="justify-content-center"
        >
          <Row className="">
            <Col xl={12} className="text-center">
             
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
}
